<span class="log-ip-field">
    <ng-container *ngIf="version === 'ipv6'">
        [
    </ng-container>
    <span
        logPartialSelectionFilter
        [property]="property"
        [value]="ip"
        [noSearchIcon]="noSearchIcons || noIpSearchIcon"
        (onFilterAdd)="onFilterAdd.emit($event)"
    ></span>
    <ng-container *ngIf="version === 'ipv6'">
        ]
    </ng-container>
    <ng-container *ngIf="ip !== undefined && port !== undefined">
        :<span
            logPartialSelectionFilter
            [property]="portProperty"
            [value]="port"
            [noSearchIcon]="noSearchIcons || noPortSearchIcon"
            position="right"
            (onFilterAdd)="onFilterAdd.emit($event)"
        ></span>
    </ng-container>
</span>
